import React from 'react';
import { Route, useParams } from 'react-router-dom';
import { WithAuthentication } from '@twigeducation/oidc-client-react';
import AccessErrorPage from '../AccessErrorPage';
import AssetPageRedirect from '../AssetPage';

const AssetPageRoute = () => {
    const { versionId } = useParams();

    return (
        <WithAuthentication
            roles={['STUDENT', 'TEACHER', 'SCHOOL_ADMIN', 'DISTRICT_OWNER', 'TWIGADMIN']}
            RoleErrorComponent={() => <AccessErrorPage link="/student-dashboard" />}
        >
            <AssetPageRedirect versionId={versionId} />
        </WithAuthentication>
    );
};

const routes = [
    <Route path="/asset/:type/:title/:versionId" exact key="asset-page">
        <AssetPageRoute />
    </Route>,
];

export default routes;
